import { render, staticRenderFns } from "./CSelectButtonsApi.vue?vue&type=template&id=6a6198ec&scoped=true&"
import script from "./CSelectButtonsApi.vue?vue&type=script&lang=ts&"
export * from "./CSelectButtonsApi.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6198ec",
  null
  
)

export default component.exports